import { Flags } from '../store/useApp.store';

export const setFlagsToLocalStorage = (flags: Flags) => localStorage.setItem('flags', JSON.stringify(flags));

export const getFlagsFromLocalStorage = () => {
  const flags = localStorage.getItem('flags') || '{}';
  return JSON.parse(flags);
};
